import { Component, OnInit, Input } from '@angular/core';
import { latestVideoService } from '../../services/latestVideo.service';

@Component({
  selector: 'app-latestvideo',
  templateUrl: './latestvideo.component.html',
  styleUrls: ['./latestvideo.component.scss'],
})
export class LatestvideoComponent implements OnInit {
  @Input() videoProducts: any;
  public isMobileLayout = false;

  constructor(private latestVideoService: latestVideoService) {}

  ngOnInit(): void {
    this.latestVideoService.getVideoProducts().subscribe((value) => {
      if (value !== undefined) {
        this.videoProducts = value;
      }
    });
    const interval = setInterval(() => {
      if (this.videoProducts && this.videoProducts.length > 0) {
        clearInterval(interval);
        this.startVideo();
        let type = 'coverflow';
        if ($(window).width() <= 530) {
          type = 'flat';
        }
        ($('.latestvideos-flipster') as any).flipster({
          style: type,
          buttons: false,
          loop: true,
        });
      }
    });

    window.onresize = () => (this.isMobileLayout = window.innerWidth <= 991);
  }

  prev() {
    ($('.latestvideos-flipster') as any).flipster('prev');
  }

  next() {
    ($('.latestvideos-flipster') as any).flipster('next');
  }

  startVideo() {
    let containerWidth = $('.latestvideos-flipster').width();
    let width = 552;
    if (containerWidth > 500) {
      width = containerWidth / 2;
    }
    if (containerWidth <= 500) {
      width = containerWidth / 2;
    }
    // For mobile
    if ($(window).width() <= 530) {
      width = $(window).width();
    }
    let height = (width * 9) / 16;
    let players: any = [];
    this.videoProducts.forEach((item: any) => {
      let player = new window['YT'].Player(item.video, {
        videoId: item.video,
        height: height,
        width: width,
        origin: 'https://www.seychelles.com/',
        playerVars: {
          enablejsapi: 1,
          rel: 0,
          showinfo: 0,
          fs: 1,
          controls: 1,
          modestbranding: 1,
        },
        events: {
          onStateChange: function (event: any) {
            if (event.data == window['YT'].PlayerState.PLAYING) {
              ($('.latestvideos-flipster') as any).flipster('jump', $('#q' + event.target.getIframe().id));
              $.each(players, function (k: number, v: any) {
                if (
                  this.getPlayerState() == window['YT'].PlayerState.PLAYING &&
                  this.getIframe().id != event.target.getIframe().id
                ) {
                  this.stopVideo();
                }
              });
            }
          },
        },
      });
      players.push(player);
    });
  }
}
